import { useRootScope } from 'FrontRoyalAngular';
import { useEffect, useState } from 'react';
import { useAppHeaderViewModel } from './useAppHeaderViewModel';

export function useLearningBoxMode() {
    const $rootScope = useRootScope();
    const AppHeaderViewModel = useAppHeaderViewModel();
    const [learningBoxMode, setLearningBoxMode] = useState(AppHeaderViewModel.learningBoxMode?.mode);

    useEffect(() => {
        const removeWatcher = $rootScope.$watch(
            () => AppHeaderViewModel.learningBoxMode?.mode,
            mode => {
                setLearningBoxMode(mode);
            },
        );

        return removeWatcher;
    }, [$rootScope, AppHeaderViewModel]);

    return learningBoxMode;
}
